export default __webpack_public_path__ + "static/bereta_logo-cacb967801292c8699994927cd4eab0b.svg";